import { EndpointBuilder } from '@reduxjs/toolkit/query/react';
import { ApiBaseQuery, ApiTagTypes } from '../types';
import { IdentityInvitation, KycDocumentType, KycStage, KycSummary, KycUploadResponse } from './types';

export const kycEndpoints = (builder: EndpointBuilder<ApiBaseQuery, ApiTagTypes, 'api'>) => ({
    getIdentityInvitation: builder.query<IdentityInvitation, string>({
        query: (token) => ({ url: '/public/kyc/identity', method: 'POST', body: { token } }),
    }),
    completeIdentityInvitation: builder.mutation<IdentityInvitation, { token: string; consent: true }>({
        query: (body) => ({ url: '/public/kyc/identity/complete', method: 'POST', body }),
        invalidatesTags: ['Kyc'],
    }),
    getKycStages: builder.query<KycStage[], void>({
        query: () => ({ url: '/private/kyc/stages/list' }),
        providesTags: ['Kyc'],
    }),
    getKycSummary: builder.query<KycSummary, void>({
        query: () => ({ url: '/private/kyc/summary' }),
        providesTags: ['Kyc'],
    }),
    uploadKycDocument: builder.mutation<KycUploadResponse, { type: KycDocumentType; file: File }>({
        query: ({ type, file }) => ({
            url: '/private/documents/upload',
            method: 'POST',
            headers: { 'Content-Type': 'application/octet-stream', 'X-Type': type },
            body: file,
        }),
        // Even a timeout can happen after the file has already been saved.
        invalidatesTags: ['Kyc'],
    }),
});
